import React, {Component} from 'react';
import { translate } from 'react-i18next';
import {connect} from 'react-redux';
import {initNavbarState} from 'actions/navbar.js';
import {fetchTeamChallengeLeaderboards} from 'actions/leaderboards.js';
import {getTeamChallengeLeaderboards, getTeamChallengeInfo} from 'reducers/leaderboards.js';
import _ from 'underscore';

import TeamChallenges from './TeamChallenges.js';

class TeamChallengesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false, selectedLeaderboard:null};
        this.onClickLeaderboard = this.onClickLeaderboard.bind(this);
        this.onClickLeaderboardIcon = this.onClickLeaderboardIcon.bind(this);
        this.onConfirmLeaderboard = this.onConfirmLeaderboard.bind(this);
        this.onCancelLeaderboard= this.onCancelLeaderboard.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode: 'main', menuEnable:true, backButtonEnable:false, rewardsEnable:true, title:this.props.t('Team Challenge')}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        this.loadData();
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData()
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    onClickLeaderboard(leaderboard) {
        if(leaderboard) {
            var challengeRecord = leaderboard.challengeRecord;
            if(challengeRecord) {
                this.props.history.push('/team-challenges/'+challengeRecord.id);
            } else {
                this.setState({selectedLeaderboard:leaderboard});
            }
        }
    }

    onClickLeaderboardIcon(leaderboard) {
        this.props.history.push('/leaderboards/'+leaderboard.id);
    }

    onConfirmLeaderboard() {
        var leaderboard = this.state.selectedLeaderboard;
        if(leaderboard) {
            this.props.history.push('/selectteam/'+leaderboard.id);
        }
    }

    onCancelLeaderboard() {
        this.setState({selectedLeaderboard:null});
    }

    render() {
        return <TeamChallenges busy={this.state.busy}
                               leaderboards={this.props.leaderboards}
                               newCount={this.props.newCount}
                               completedCount={this.props.completedCount}
                               teamChallengeInfo={this.props.teamChallengeInfo}
                               selectedLeaderboard={this.state.selectedLeaderboard}
                               onClickLeaderboardIcon={this.onClickLeaderboardIcon}
                               onClickLeaderboard={this.onClickLeaderboard}
                               onConfirmLeaderboard={this.onConfirmLeaderboard}
                               onCancelLeaderboard={this.onCancelLeaderboard} />;
    }
}


const mapStateToProps = (state) => {
    var leaderboards = getTeamChallengeLeaderboards(state.leaderboards);
    var completedCount = 0;
    var newCount = 0;
    if(leaderboards) {
        for(var i = 0; i < leaderboards.length; i++) {
            var leaderboard = leaderboards[i];
            if(_.isFinite(leaderboard.rank) && leaderboard.rank>0) {
                completedCount++;
            }
        }
        newCount = leaderboards.length - completedCount;
    }
    return {leaderboards:leaderboards,
            teamChallengeInfo:getTeamChallengeInfo(state.leaderboards),
            newCount:newCount, 
            completedCount:completedCount};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(fetchTeamChallengeLeaderboards(true)),
        dispatch: dispatch
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(translate('teamchallenges')(TeamChallengesContainer));



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/TeamChallengesContainer.js